module.exports = __webpack_public_path__ + "images/top-trending-blue-76a9d64d.svg";